export var PlayerType;
(function (PlayerType) {
    PlayerType["CHROMELESS"] = "chromeless";
    PlayerType["FULL"] = "full";
})(PlayerType || (PlayerType = {}));
